import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { legalContent, siteInfo } from '@/data/mock';
import { Shield, Mail } from 'lucide-react';

const PolitiqueConfidentialitePage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="pt-32 pb-16 bg-[var(--surface-cream)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <div className="flex justify-center mb-6">
              <div className="feature-icon !w-16 !h-16">
                <Shield className="w-7 h-7" />
              </div>
            </div>
            <h1 className="font-serif text-4xl sm:text-5xl text-[var(--text-primary)] mb-6">
              Politique de Confidentialité
            </h1>
            <div className="w-24 h-px bg-[var(--color-gold)] mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Contact Card */}
          <div className="p-6 bg-[var(--surface-cream)] rounded-xl mb-12">
            <h3 className="font-medium text-[var(--text-primary)] mb-4">Pour exercer vos droits</h3>
            <a
              href={`mailto:${siteInfo.email}`}
              className="flex items-center gap-3 text-[var(--color-gold)] hover:underline"
            >
              <Mail className="w-5 h-5" />
              {siteInfo.email}
            </a>
          </div>

          {/* Full Legal Text */}
          <div className="prose prose-lg max-w-none">
            {legalContent.politiqueConfidentialite.split('\n\n').map((section, index) => {
              // Check if it's a title (all caps)
              const isTitle = section === section.toUpperCase() && section.length < 100;
              
              if (isTitle) {
                return (
                  <h2 key={index} className="font-serif text-xl text-[var(--text-primary)] mt-12 mb-4 border-b border-[var(--color-beige)] pb-2">
                    {section}
                  </h2>
                );
              }
              
              // Check if it contains bullet points
              if (section.includes('•')) {
                const lines = section.split('\n');
                const firstLine = lines[0];
                const bullets = lines.slice(1);
                
                return (
                  <div key={index} className="mb-6">
                    {firstLine && !firstLine.startsWith('•') && (
                      <p className="text-[var(--text-secondary)] leading-relaxed mb-3">
                        {firstLine}
                      </p>
                    )}
                    <ul className="space-y-2">
                      {(firstLine.startsWith('•') ? lines : bullets).map((bullet, i) => (
                        <li key={i} className="flex items-start gap-3 text-[var(--text-secondary)]">
                          <span className="w-2 h-2 bg-[var(--color-gold)] rounded-full mt-2 flex-shrink-0"></span>
                          <span>{bullet.replace('• ', '')}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              }
              
              return (
                <p key={index} className="text-[var(--text-secondary)] leading-relaxed mb-4">
                  {section}
                </p>
              );
            })}
          </div>

          {/* RGPD Rights Summary */}
          <div className="mt-12 p-6 bg-[var(--surface-cream)] rounded-xl">
            <h3 className="font-medium text-[var(--text-primary)] mb-4">Vos droits RGPD en résumé</h3>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                "Droit d'accès",
                "Droit de rectification",
                "Droit à l'effacement",
                "Droit à la limitation",
                "Droit d'opposition",
                "Droit à la portabilité",
                "Droit de retrait du consentement"
              ].map((right, index) => (
                <div key={index} className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-[var(--color-gold)] rounded-full"></span>
                  <span className="text-sm text-[var(--text-secondary)]">{right}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PolitiqueConfidentialitePage;
